import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ApproveModerationRequest,
  GetChannelsRequest,
  GetChannelsResponse,
  GetFlagsResponse,
  GetReportsCountersResponse,
  GetReportsRequest,
  GetReportsResponse,
  GetUsersRequest,
  GetUsersResponse,
  IModerationState,
  ITopChannelResponse,
  RejectModerationRequest,
  Report,
} from './types';

export const initialState: IModerationState = {
  moderationLoader: false,
  counters: null,
  approveResponse: null,
  rejectResponse: null,
  flagsResponse: null,
  reportsResponse: null,
  usersResponse: null,
  channelsResponse: null,
  topUsers: null,
  topChannels: null,
};

// --- Slice ---

const moderation = createSlice({
  name: '@@moderation',
  initialState,
  reducers: {
    // counters
    getModerationReportsCountersRequest: (state) => {
      state.moderationLoader = true;
    },
    getModerationReportsCountersSuccess: (
      state,
      action: PayloadAction<GetReportsCountersResponse>,
    ) => {
      state.moderationLoader = false;
      state.counters = action.payload;
    },
    getModerationReportsCountersFailure: (state) => {
      state.moderationLoader = false;
      state.counters = null;
    },

    // reports list
    getModerationReportsRequest: (state, _action: PayloadAction<GetReportsRequest>) => {
      state.moderationLoader = true;
      state.reportsResponse = null;
    },
    getModerationReportsSuccess: (state, action: PayloadAction<GetReportsResponse>) => {
      state.moderationLoader = false;
      state.reportsResponse = action.payload;
    },
    getModerationReportsFailure: (state) => {
      state.moderationLoader = false;
      state.reportsResponse = null;
    },

    // flags
    getModerationFlagsRequest: (state) => {
      state.moderationLoader = true;
      state.flagsResponse = null;
    },
    getModerationFlagsSuccess: (state, action: PayloadAction<GetFlagsResponse>) => {
      state.moderationLoader = false;
      state.flagsResponse = action.payload;
    },
    getModerationFlagsFailure: (state) => {
      state.moderationLoader = false;
      state.flagsResponse = null;
    },

    // approve
    approveModerationRequest: (state, _action: PayloadAction<ApproveModerationRequest>) => {
      state.moderationLoader = true;
      state.approveResponse = null;
    },
    approveModerationSuccess: (state, action: PayloadAction<Array<Report>>) => {
      state.moderationLoader = false;
      if (state.reportsResponse && state.reportsResponse.data?.[0]) {
        state.reportsResponse.data[0].report = action.payload[0];
      }
    },
    approveModerationFailure: (state) => {
      state.moderationLoader = false;
      state.approveResponse = null;
    },

    // reject
    rejectModerationRequest: (state, _action: PayloadAction<RejectModerationRequest>) => {
      state.moderationLoader = true;
      state.rejectResponse = null;
    },
    rejectModerationSuccess: (state, action: PayloadAction<Array<Report>>) => {
      state.moderationLoader = false;
      if (state.reportsResponse && state.reportsResponse.data?.[0]) {
        state.reportsResponse.data[0].report = action.payload[0];
      }
    },
    rejectModerationFailure: (state) => {
      state.moderationLoader = false;
      state.rejectResponse = null;
    },

    // get users
    getModerationUsersRequest: (state, _action: PayloadAction<GetUsersRequest>) => {
      state.moderationLoader = true;
      state.usersResponse = null;
    },
    getModerationUsersSuccess: (state, action: PayloadAction<GetUsersResponse>) => {
      state.moderationLoader = false;
      state.usersResponse = action.payload;
    },
    getModerationUsersFailure: (state) => {
      state.moderationLoader = false;
      state.usersResponse = null;
    },

    // get channels
    getModerationChannelsRequest: (state, _action: PayloadAction<GetChannelsRequest>) => {
      state.moderationLoader = true;
      state.channelsResponse = null;
    },
    getModerationChannelsSuccess: (state, action: PayloadAction<GetChannelsResponse>) => {
      state.moderationLoader = false;
      state.channelsResponse = action.payload;
    },
    getModerationChannelsFailure: (state) => {
      state.moderationLoader = false;
      state.channelsResponse = null;
    },

    // get top channels
    getTopChannelsRequest: (state) => {
      state.moderationLoader = true;
      state.channelsResponse = null;
    },
    getTopChannelsSuccess: (state, action: PayloadAction<ITopChannelResponse>) => {
      state.moderationLoader = false;
      state.topChannels = action.payload;
    },
    getTopChannelsFailure: (state) => {
      state.moderationLoader = false;
      state.channelsResponse = null;
    },

    // get top Users
    getTopUsersRequest: (state) => {
      state.moderationLoader = true;
      state.channelsResponse = null;
    },
    getTopUsersSuccess: (state, action: PayloadAction<any>) => {
      state.moderationLoader = false;
      state.topUsers = action.payload;
    },
    getTopUsersFailure: (state) => {
      state.moderationLoader = false;
      state.channelsResponse = null;
    },

    // reset (використовуєш у finally)
    moderationInitState: (state) => {
      state.moderationLoader = false;
    },
  },
});

export default moderation.reducer;

export const {
  getModerationReportsCountersRequest,
  getModerationReportsCountersSuccess,
  getModerationReportsCountersFailure,
  getModerationReportsRequest,
  getModerationReportsSuccess,
  getModerationReportsFailure,
  getModerationFlagsRequest,
  getModerationFlagsSuccess,
  getModerationFlagsFailure,
  approveModerationRequest,
  approveModerationSuccess,
  approveModerationFailure,
  rejectModerationRequest,
  rejectModerationSuccess,
  rejectModerationFailure,
  getModerationUsersRequest,
  getModerationUsersSuccess,
  getModerationUsersFailure,
  getModerationChannelsRequest,
  getModerationChannelsSuccess,
  getModerationChannelsFailure,
  getTopChannelsRequest,
  getTopChannelsSuccess,
  getTopChannelsFailure,
  getTopUsersRequest,
  getTopUsersSuccess,
  getTopUsersFailure,
  moderationInitState,
} = moderation.actions;
